import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "children", "isHistory", "className"],
  _excluded2 = ["dispatch", "shouldRender"];
import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
export var CommonBlock = function CommonBlock(_ref) {
  var title = _ref.title,
    children = _ref.children,
    isHistory = _ref.isHistory,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = otherProps,
    dispatch = _ref2.dispatch,
    shouldRender = _ref2.shouldRender,
    metrics = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('common-block')
  }, metrics, {
    "data-t-id": "CommonBlock-shared"
  }), title && /*#__PURE__*/React.createElement(Text, {
    className: cx('common-block__title'),
    color: "tertiary-invert",
    size: "xs"
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: cx('common-block__list', {
      'common-block__list-history': isHistory
    }, className)
  }, children));
};